import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "track", "thumb", "checkIcon", "xIcon"]
  static values = {
    checked: Boolean,
    variant: String
  }

  connect() {
    this.updateUI()
  }

  toggle() {
    this.checkedValue = this.inputTarget.checked
    this.updateUI()
  }

  updateUI() {
    const isChecked = this.inputTarget.checked

    if (this.variantValue === "default") {
      if (isChecked) {
        this.thumbTarget.classList.add("!right-1", "!bg-primary", "dark:!bg-white")
        this.thumbTarget.style.setProperty("left", "auto")
        this.thumbTarget.style.setProperty("right", "0.25rem")
      } else {
        this.thumbTarget.classList.remove("!right-1", "!bg-primary", "dark:!bg-white")
        this.thumbTarget.style.removeProperty("left")
        this.thumbTarget.style.removeProperty("right")
      }
    } else if (this.variantValue === "shadow") {
      if (isChecked) {
        this.thumbTarget.classList.add("!right-0", "!bg-primary", "dark:!bg-white")
        this.thumbTarget.style.setProperty("left", "auto")
        this.thumbTarget.style.setProperty("right", "0")
      } else {
        this.thumbTarget.classList.remove("!right-0", "!bg-primary", "dark:!bg-white")
        this.thumbTarget.style.removeProperty("left")
        this.thumbTarget.style.removeProperty("right")
      }
    } else if (this.variantValue === "icon") {
      if (isChecked) {
        this.thumbTarget.classList.add("!right-1", "!bg-primary", "dark:!bg-white")
        this.thumbTarget.style.setProperty("left", "auto")
        this.thumbTarget.style.setProperty("right", "0.25rem")
        if (this.hasCheckIconTarget) {
          this.checkIconTarget.classList.remove("hidden")
          this.checkIconTarget.classList.add("!block")
        }
        if (this.hasXIconTarget) {
          this.xIconTarget.classList.add("hidden")
        }
      } else {
        this.thumbTarget.classList.remove("!right-1", "!bg-primary", "dark:!bg-white")
        this.thumbTarget.style.removeProperty("left")
        this.thumbTarget.style.removeProperty("right")
        if (this.hasCheckIconTarget) {
          this.checkIconTarget.classList.add("hidden")
          this.checkIconTarget.classList.remove("!block")
        }
        if (this.hasXIconTarget) {
          this.xIconTarget.classList.remove("hidden")
        }
      }
    } else if (this.variantValue === "black") {
      if (isChecked) {
        this.trackTarget.classList.add("!bg-primary")
        this.thumbTarget.classList.add("!right-1")
        this.thumbTarget.style.setProperty("left", "auto")
        this.thumbTarget.style.setProperty("right", "0.25rem")
      } else {
        this.trackTarget.classList.remove("!bg-primary")
        this.thumbTarget.classList.remove( "!right-1")
        this.thumbTarget.style.removeProperty("left")
        this.thumbTarget.style.removeProperty("right")
      }
    }
  }
}
